export class CreateApplicationLocationWConstants {
    static STEP_TITLE = "Location";
    static DESCRIPTION_LABEL_1 = "Please draw a point, line or polygon on the map to indicate the location of the wayleave.";
    static TRUE_CENTROID = "True centroid gp shared-services";
}
